/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmNotificationConfig {
    getFixupPrototypeFunction() { return AwsSsmNotificationConfig.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmNotificationConfig>): AwsSsmNotificationConfig {
        let obj = Object.assign(new AwsSsmNotificationConfig(), model);
        AwsSsmNotificationConfig.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmNotificationConfig>): AwsSsmNotificationConfig {
        if (!model) return null;
        return AwsSsmNotificationConfig.newInstance(<AwsSsmNotificationConfig> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmNotificationConfig) {
        if (!obj) return;

        models.AwsSsmNotificationConfig.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmNotificationConfig): boolean {
        Object.setPrototypeOf(obj, AwsSsmNotificationConfig.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * AWS resource ARN of the SNS topic
     */
    arn: string;

    events: Array<models.AwsSsmExecuteDocumentNotificationEvents>;

    /**
     * Type of the notification. Receive notifications when the status of command/invocation changes
     */
    notification_type: models.AwsSsmCommandNotificationTypes;

}
